import Http from './../http';

const prefix = '/page';
const configuration = '-configuration';

export const get = encryptedId => {
  return Http.authApi().get(`${prefix}/${encryptedId}`);
};

export const getBit = encryptedId => {
  return Http.authApi().get(`${prefix}/bit/${encryptedId}`);
};

export const getWithoutAuth = id => {
  return Http.webAction().get(`${prefix}/without-auth/${id}`);
};

export const create = page => Http.authApi().post(`${prefix}`, page);

export const edit = page => {
  return Http.authApi().put(`${prefix}/${page.encrypted_id}`, page);
};

export const reorderPages = data => {
  return Http.authApi().post(`${prefix}/reorder-pages/sort`, data);
};

export const editConfiguration = page => {
  return Http.authApi().put(
    `${prefix}${configuration}/${page.encrypted_id}`,
    page
  );
};

export const exclude = page => {
  return Http.authApi().delete(`${prefix}/${page.encrypted_id}`, page);
};
export const deletedPagesSelected = (websiteId, data) => {
  return Http.authApi().post(`${prefix}/delete-selected-pages/${websiteId}`, data);
};

export const duplicate = page => {
  return Http.authApi().post(`duplicate/page/${page.encrypted_id}`);
};

export const getPagesFromWebsite = websiteId => {
  return Http.authApi().get(`${prefix}s/from-website/${websiteId}`);
};

export const createMembers = website => Http.authApi().post(`${prefix}-members`, website);


export const getVersions = (website_id, page_id) => Http.authApi().get(`${prefix}/get-versions/${website_id}/${page_id}`);

export const getDeletedPages = (website_id) => Http.authApi().get(`${prefix}/get-deleted/${website_id}`);

export const setActiveVersion = (website_id, page_id, version_id) => Http.authApi().post(`${prefix}/set-version/${website_id}/${page_id}/${version_id}`);

export const restoreDeleted = (page_id) => Http.authApi().post(`${prefix}/restore-deleted`, { page_id : page_id });



// WEBPACK FOOTER //
// ./src/js/services/editor/page.js